<template>
  <div class="system-dic-dialog-container">
    <el-dialog :title="title" :visible.sync="isShowDialog" width="969px">
      <el-form
        ref="dicDialogFormRef"
        :model="formData"
        v-loading="isLoading"
        :rules="rules"
        size="small"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="标题" prop="Name">
              <el-input
                v-model="formData.Name"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="考试时间" prop="ExamTime">
              <!-- <el-date-picker v-model="formData.ExamTime" type="date" style="width: 100%;"
                                value-format="yyyy-MM-dd" placeholder="选择日期">
                            </el-date-picker> -->
              <el-date-picker
                v-model="formData.ExamTime"
                type="datetime"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="截止日期" prop="EndTime">
              <el-date-picker
                v-model="formData.EndTime"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="报名费用" prop="Price">
              <el-input
                type="number"
                v-model="formData.Price"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="模板" prop="Url">
              <el-upload
                class="upload-demo"
                :action="upLoadApi"
                :limit="1"
                drag
                :file-list="fileList"
                :data="{ Type: 5 }"
                accept=".doc, .docx, .xls, .xlsx"
                :on-exceed="exceed"
                :on-success="onSuccess"
                :on-remove="onRemove"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
                <div slot="tip" class="el-upload__tip">
                  只能上传doc/docx/xls/xlsx文件，且不超过1000kb
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="内容" prop="Content">
              <div style="border: 1px solid #ccc; box-sizing: border-box">
                <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                />
                <Editor
                  :style="`height: 300px; overflow-y: hidden;`"
                  :defaultConfig="editorConfig"
                  v-model="formData.Content"
                  @onCreated="onCreated"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="onCancel" size="default">取 消</el-button>
          <el-button
            :loading="btnLoading"
            type="primary"
            @click="onSubmit"
            size="default"
            >保存</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  PostSelectRecruitmentTemplateDetail,
  PostAddRecruitmentTemplate,
  PutRecruitmentTemplate,
} from "@/api/RecruitmentTemplate/RecruitmentTemplate";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { uploadFile } from "@/api/upload/upload";
import * as Api from "../../api/api";

export default {
  components: { Editor, Toolbar },
  data() {
    return {
      upLoadApi: "",
      fileList: [],
      editor: null,
      key: "edit",
      title: "编辑",
      isShowDialog: false,
      isLoading: false,
      btnLoading: false,
      formData: {},
      rules: {
        Name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        ExamTime: [
          { required: true, message: "请选择考试时间", trigger: "change" },
        ],
        EndTime: [
          { required: true, message: "请选择截止时间", trigger: "change" },
        ],
        Price: [
          { required: true, message: "请输入报名费用", trigger: "change" },
        ],
        Url: [{ required: true, message: "请上传模板", trigger: "change" }],
        Content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              let res = await uploadFile(file);
              if (res.status == 200) {
                let raw = res.response || {};
                let url = raw.Url;
                let alt = file.name;
                let href = ``;
                insertFn(url, alt, href);
              } else {
                this.$message.error("图片上传失败");
              }
            },
          },
          uploadVideo: {
            async customUpload(file, insertFn) {
              let res = await uploadFile(file);
              if (res.status == 200) {
                let raw = res.response || {};
                let url = raw.Url;
                let poster = "";

                insertFn(url, poster);
              } else {
                this.$message.error("视频上传失败");
              }
            },
          },
        },
      },
    };
  },
  mounted() {
    this.upLoadApi = Api.uploadUrl;
  },
  computed: {},
  methods: {
    exceed(file, fileList) {
      this.$message.error("只能上传一份");
    },
    onSuccess(response, file, fileList) {
      let url = response.response.Url;
      let name = response.response.FileName;
      this.formData.Url = url;
      this.formData.FileTemplat = name;
      this.fileList = [{ url, name }];
    },
    onRemove(file, fileList) {
      this.fileList = [];
      this.formData.Url = "";
      this.formData.FileTemplat = "";
    },
    openDialog(e, key) {
      this.fileList = [];
      this.key = key;
      this.resetForm("");
      let dic = {
        edit: "编辑",
        add: "新增",
      };
      this.title = dic[key];
      key == "edit" && this.HttpQueryBlogDetail({ Id: e.Id });
      key == "add" &&
        (this.formData = {
          Url: "",
          Content: "",
        });
      this.isShowDialog = true;
    },
    resetForm(formName) {
      this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
    },
    onCancel() {
      this.isShowDialog = false;
    },
    handleAvatarSuccess(res, file) {
      this.formData.Picture = res.response.Url;
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes("image");
      const isLt4M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$message.error("上传头像图片只能是图片格式!");
      }
      // if (!isLt4M) {
      //   this.$message.error("上传图片大小不能超过 10MB!");
      // }
      // return isImage && isLt4M;
      return isImage;
    },
    onSubmit() {
      this.btnLoading = true;
      let that = this;
      this.$refs.dicDialogFormRef.validate((valid) => {
        this.btnLoading = false;
        if (valid) {
          that.submit();
        } else {
          console.log("error submit!!", valid);
          return false;
        }
      });
    },
    submit() {
      let param = this.formData;
      if (param.Content == `<p><br></p>`) {
        this.$message.error("请输入内容");
        return;
      }
      this.key == "add" && this.HttpAddBlogDetail(param);
      this.key == "edit" && this.HttpUpdateBlogDetail(param);
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    async HttpQueryBlogDetail(param) {
      this.isLoading = true;
      const response = await PostSelectRecruitmentTemplateDetail(param);
      this.isLoading = false;
      let res = response.data;
      if (res.status == 200) {
        let raw = res.response || {};
        this.fileList = [
          {
            name: raw.FileTemplat,
            url: raw.Url,
          },
        ];
        this.formData = raw;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpUpdateBlogDetail(param) {
      this.btnLoading = true;
      const response = await PutRecruitmentTemplate(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpAddBlogDetail(param) {
      this.btnLoading = true;
      const response = await PostAddRecruitmentTemplate(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
